var _g, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7324_19211)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9861 38.8946C79.956 59.9389 64.38 75.1864 45.6329 72.9526C26.8859 70.7196 11.3645 55.4716 11.334 38.8946C11.3649 22.3171 26.8855 7.06913 45.6329 4.83612C64.3804 2.60231 79.956 17.8503 79.9861 38.8946Z",
    fill: "#E9ECF2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7324_19211)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7722 34.4085C68.7421 55.4528 53.1661 70.7003 34.4191 68.4665C15.672 66.2335 0.150635 50.9856 0.120117 34.4085C0.151036 17.831 15.6716 2.58304 34.4191 0.350038C53.1665 -1.88377 68.7421 13.3642 68.7722 34.4085Z",
    fill: "#789BE7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.1777 34.9787L32.2709 44.6781L45.6076 24.6731",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7324_19211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.785,
    height: 68.785,
    fill: "white",
    transform: "translate(11.2139 4.48608)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7324_19211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.785,
    height: 68.785,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8ad15d4ec00d37e0631b8dbcd2a58373.svg";
export { ForwardRef as ReactComponent };